import { get, size, map, trim, isFunction, head, compact, eq } from 'lodash';
import { getTranslationKey } from './index';
import { IDictionary } from '../../types';

type TFormValue = string | number | boolean | string[];

interface IValidateOptions {
  formValues: IDictionary<string>;
  titleKey: string;
}

type TValidation = (value: TFormValue, options: IValidateOptions) => string | undefined;

const required = (value: TFormValue) =>
  !Boolean(value) || (typeof value === 'string' ? !value.length : false);
const maxFunction = (value: string, max: number) => {
  if (size(value) > max) {
    return `Max ${max} Characters`;
  }
};
export const validations: IDictionary<TValidation> = {
  required: (value: TFormValue, options: IValidateOptions) => {
    console.log(value);
    if (required(value)) {
      const title = get(options, 'titleKey', '');

      return `${getTranslationKey(title)} ${getTranslationKey('baseValidations.required')}`;
    }
  },
  onlyLetters: (value: TFormValue, options: IValidateOptions) => {
    if (typeof value !== 'string') return;
    const regrxp = /^[a-zA-Z\s\-üäöâáß]+$/;
    const test = value.match(regrxp);
    if (!test) {
      const title = get(options, 'titleKey', '');

      return `${getTranslationKey(title)}`;
    }
  },
  max250: (value: TFormValue) => {
    if (typeof value !== 'string') return;

    return maxFunction(value, 250);
  },
  emailFormat: (value: TFormValue, options: IValidateOptions) => {
    if (typeof value !== 'string') return;
    const regrxp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const test = value.match(regrxp);
    if (!test) {
      const title = get(options, 'titleKey', '');

      return getTranslationKey(title);
    }
  },
  onlyNumber: (value: TFormValue, options: IValidateOptions) => {
    if (typeof value !== 'string') return;
    const regrxp = /^[0-9]+$/;
    const test = value.match(regrxp);
    if (!test) {
      const title = get(options, 'titleKey', '');

      return `${getTranslationKey(title)} ${getTranslationKey('baseValidations.onlyNumbers')}`;
    }
  },
  onlyAlfaNumeric: (value: TFormValue, options: IValidateOptions) => {
    if (typeof value !== 'string') return;
    const regrxp = /^[a-z0-9]+$/;
    const test = value.match(regrxp);
    if (!test) {
      const title = get(options, 'titleKey', '');

      return `${getTranslationKey(title)} should contain only letters and digits`;
    }
  },
  matchPassword: (value: TFormValue, { formValues }: IValidateOptions) => {
    if (typeof value !== 'string') return;
    const password = get(formValues, 'password.value', '');
    if (!eq(password, value)) {
      return 'Password does not match';
    }
  },
  emailsList: (value: TFormValue) => {
    if (!Array.isArray(value)) return;
    const regrxp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let foundInvalid = false;
    let i = 0;
    do {
      const testValue = value[i] || '';
      foundInvalid = !Boolean(testValue.trim().match(regrxp));
      i++;
    } while (!foundInvalid && value.length > i);
    if (foundInvalid) {
      return getTranslationKey('baseValidations.invalidEmails');
    }
  }
};

export const valueOfElement = (target: Element) => {
  const is_checkbox = get(target, 'type') === 'checkbox';
  const checkboxValue = get(target, 'checked', 0) ? 1 : 0;

  return is_checkbox ? checkboxValue : get(target, 'value', '');
};

export const validateField = (e: HTMLFormElement, formValues: IDictionary<string>) => {
  const value = valueOfElement(e);
  const name = e.getAttribute('name');
  const titleKey = e.getAttribute('data-required') || e.getAttribute('title') || '';
  const validate_options = {
    formValues,
    titleKey,
    name
  };

  if (!name) {
    return false;
  }

  const element_validations = e.getAttribute('data-validations') || '';
  const functions = [...element_validations.split(',')];
  if (size(functions)) {
    const errors = map(functions, (f: string) => {
      const func = validations[trim(f)];

      return isFunction(func) && func(value, validate_options);
    });
    const top_error = head(compact(errors));
    if (top_error) {
      return {
        name,
        errorText: top_error
      };
    }
  }
};

export interface IFormFieldData {
  value: TFormValue;
  error: string;
  validations?: string;
  titleKey?: string;
}

export const validateFieldStore = (
  name: string,
  formField: IFormFieldData,
  formValues: IDictionary<string>
): { name: string; errorText: string } | undefined => {
  const { value, titleKey = '', validations: fieldValidations = '' } = formField;
  const validate_options = {
    formValues,
    titleKey,
    name
  };
  if (!name) {
    return;
  }
  const functions = [...fieldValidations.split(',')];
  if (size(functions)) {
    const errors = map(functions, (f: string) => {
      const func = validations[trim(f)];

      return isFunction(func) && func(value, validate_options);
    });
    const top_error = head(compact(errors));
    if (top_error) {
      return {
        name,
        errorText: top_error
      };
    }
  }
};
